define([
    'text!./templates/mfp-car-data.html',
    'edge/platform/util/LocalDateUtil',
    ],
    (templateStr, LocalDateUtil) => {

        directive.$inject = ['BaslerCommonService', 'ContextService'];
        function directive(BaslerCommonService, ContextService) {
            return {
                restrict: 'E',
                scope: {
                    contact: '=',
                    readonly: '=',
                    licensePlateNr: '=',
                    mainVehicle: '=',
                    additionalVehicle: '=?',
                    periodStartDate: '=?',
                },
                template: templateStr,
                link: linkFn,
            };

            function linkFn($scope) {
                $scope.formatDate = formatDate;
                $scope.formatMatriculationNr = formatMatriculationNr;
                $scope.mainVehiclePlaceholder = $scope.additionalVehicle ? $scope.mainVehicle.value.displayName : undefined;
                $scope.additionalVehiclePlaceholder = $scope.additionalVehicle ? $scope.additionalVehicle.value.displayName : undefined;
                $scope.showRegistrationDate = showRegistrationDate;
                $scope.minDate = new Date();
                $scope.maxDate = new Date();
                $scope.maxDate.setUTCFullYear($scope.maxDate.getUTCFullYear() + 1);

                if (ContextService.isPartnerLeasingProduct()) {
                    initializeRegistrationDate($scope.mainVehicle);
                    initializeRegistrationDate($scope.additionalVehicle);
                }

                function formatDate(isoString) {
                    return BaslerCommonService.formatDate(isoString);
                }

                function showRegistrationDate() {
                    return ContextService.isPartnerLeasingProduct();
                }

                function initializeRegistrationDate(vehicle) {
                    if (vehicle) {
                        vehicle.registrationDateDTO = {};
                        if (LocalDateUtil.toMidnightDate($scope.periodStartDate.value) < new Date()) {
                            vehicle.registrationDateDTO.registrationDate = LocalDateUtil.toLocalDate(new Date());
                        } else {
                            vehicle.registrationDateDTO.registrationDate = $scope.periodStartDate.value;
                        }
                    }
                }

                // Reformat the matriculation number to the format of NNN.NNN.NNN if it is not formatted yet
                function formatMatriculationNr(vehicle) {
                    vehicle.matriculationInformation.matriculationNumber.value = restrictStringLength(vehicle.matriculationInformation.matriculationNumber.value, 11);
                    const matNr = vehicle.matriculationInformation.matriculationNumber.value;
                    const myRegexp = /(^)([0-9]{3})\.?([0-9]{3})\.?([0-9]{3})($)/g;
                    const pattern = new RegExp(myRegexp);
                    if (pattern.test(matNr)) {
                        const match = myRegexp.exec(matNr);
                        vehicle.matriculationInformation.matriculationNumber.value = `${match[2]}.${match[3]}.${match[4]}`;
                    }
                }

                function restrictStringLength(str, length) {
                    if (str && str.length > length) {
                        return str.substring(0, length);
                    }
                    
                        return str;
                    
                }
            }
        }

        return directive;
    });



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/mfp/directives/MFPCarData.js